import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, message, Upload, UploadProps, Col, Row, Modal, Typography } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { MessageType } from 'models/MessageType';
import { hasUploadedFile } from 'components/form';
import { RcFile } from 'antd/es/upload';
import uploudlistIcon from 'assets/images/support/uploudlist.svg';
// import { reject } from 'lodash';
const { Text } = Typography;

const TEN_MB = 10 * 1024 * 1024;
const MAX_PER_FILE_SIZE = TEN_MB;
const MAX_SIZE = TEN_MB * 2;
const MAX_NUMBER_OF_ATTACHMENTS = 2;
type DocumentsCardType = {
  setInvalid: (invalid: boolean) => void;
  onFileChange?: (files: UploadFile[]) => void;
};
export const DocumentsCardPep = ({ setInvalid, onFileChange }: DocumentsCardType) => {
  const { t } = useTranslation();
  const [exceedNo, setExceedNo] = useState(false);
  const [exceedSize, setExceedSize] = useState(false);
  const [attachments, setAttachments] = useState<UploadFile[]>([]);
  useEffect(() => {
    if (attachments.length <= 0) {
      setInvalid(false);
    } else {
      setInvalid(exceedSize || exceedNo);
    }
    // 通知父组件文件变化，并传递 fieldName 标识
    onFileChange?.(attachments);
    // eslint-disable-next-line
  }, [exceedNo, exceedSize, setInvalid, attachments]);

  const attachmentUploadProps: UploadProps = useMemo(
    () => ({
      fileList: attachments,
      listType: 'picture',
      multiple: false,
      accept: 'image/*,application/pdf',
      onChange: ({ fileList }) => {
        const totalSize = fileList.map((a) => a.size || 0).reduce((acc, cur) => acc + cur, 0);
        setExceedSize(totalSize > MAX_SIZE);
        setExceedNo(fileList.length > MAX_NUMBER_OF_ATTACHMENTS);
        setAttachments(fileList);
      },
      onRemove: () => {
        return new Promise((resolve) => {
          Modal.confirm({
            title: '',
            icon: '',
            width: 510,
            className: 'Modalconfirm',
            centered: true,
            okText: `${t('life.enquiry.Cancel')}`,
            cancelText: `${t('life.enquiry.delete')}`,
            content: `${t('life.enquiry.sureToDelete')}`,
            onOk: () => {
              return false;
            },
            onCancel: () => {
              return resolve(true);
            },
          });
        });
      },

      beforeUpload: (f) => {
        if (hasUploadedFile(attachments as RcFile[], f)) {
          message[MessageType.ERROR](t('common.error.notAllowUploadSameDocument'));
          return Upload.LIST_IGNORE;
        }

        if (f.size > MAX_PER_FILE_SIZE) {
          message[MessageType.ERROR](t('common.error.sizeExceeds', { amount: 10 }));
          return Upload.LIST_IGNORE;
        }
        // 检查文件类型
        if (f.type.indexOf('image/') !== 0 && f.type !== 'application/pdf') {
          message[MessageType.ERROR](t('common.error.notPdfOrImages'));
          return Upload.LIST_IGNORE;
        }
        return false;
      },
      onPreview: (file) => {
        if (file.originFileObj) {
          const url = URL.createObjectURL(file.originFileObj as Blob);
          window.open(url, '_blank');
        }
      },
    }),
    [attachments, t],
  );

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="upload-files">
      <Col xs={24} md={24}>
        <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '22px', fontFamily: 'Roboto400' }}>
          {t('life.beneficiaries.upload.title')}
        </span>
        <div
          style={{
            color: '#6f7072',
            fontWeight: 'normal',
            fontSize: '17px',
            fontFamily: 'Roboto400',
            marginTop: '8px',
          }}
        >
          {t('life.beneficiaries.upload.supplementary')}
        </div>
        <div
          style={{
            color: '#6f7072',
            fontWeight: 'normal',
            fontSize: '15px',
            fontFamily: 'Roboto400',
            marginTop: '8px',
          }}
          className="more-desc"
        >
          {t('life.beneficiaries.upload.identification')}
        </div>
        <div
          style={{
            color: '#6f7072',
            fontWeight: 'normal',
            fontSize: '15px',
            fontFamily: 'Roboto400',
            whiteSpace: 'pre-line',
            marginTop: '8px',
          }}
        >
          {t('life.MakeRequest.contact.uploadDescForCI')}
        </div>
        <Upload name="pepAttachments" {...attachmentUploadProps}>
          <div className="buttoncontent" style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className="button" disabled={attachments.length >= MAX_NUMBER_OF_ATTACHMENTS}>
              {t('enquiry.upload')}
            </Button>
          </div>
          <div
            style={{
              color: '#B0B2B3',
              fontWeight: 'normal',
              fontSize: '17px',
              fontFamily: 'Roboto400',
              marginTop: '20px',
            }}
          >
            <img src={uploudlistIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
            {t('life.enquiry.uploadedAttr')}
          </div>
        </Upload>
      </Col>
      {exceedSize && <Text type="danger">{t('common.error.sizeExceeds', { amount: 10 })}</Text>}
      {attachments.length >= MAX_NUMBER_OF_ATTACHMENTS && (
        <Text type="danger">{t('common.error.noOfFilesExceedZdy', { amount: MAX_NUMBER_OF_ATTACHMENTS })}</Text>
      )}
    </Row>
  );
};
